import React from "react"
import { FlashOn, ErrorOutline } from "@material-ui/icons"
import CustomizedChip from "../CustomizedChip"

export const RenderLowStockWarning = () => <CustomizedChip color="secondary" icon={<FlashOn />} label="LOW STOCK" />

export const RenderSoldOut = () => <CustomizedChip color="primary" icon={<ErrorOutline />} label="SOLD OUT" />

export const RenderSoldOutShort = () => <CustomizedChip color="primary" label="SOLD OUT" />
